export default ['Feed Material', 'Properties', 'Carbon Footprint'];
